import video from "../../../../content/posts/2023-02-02-toc/images/intersection-observer-debugger.mp4";
import example from "../../../../content/posts/2023-02-02-toc/observe-active-example.js";
import poster from "../../../../content/posts/2023-02-02-toc/images/example-poster.png";
import * as React from 'react';
export default {
  video,
  example,
  poster,
  React
};